import React, { useEffect } from 'react';
import { AppLayout, ContentLayout, Button, Container, Header, SpaceBetween, SideNavigation } from '@cloudscape-design/components';
import { useAuth } from './AuthContext';
import { CognitoJwtVerifier } from 'aws-jwt-verify';
import { useNavigate } from 'react-router-dom';
import { BreadcrumbGroup } from '@cloudscape-design/components';
import './LandingPage.css';
import AwsLogo from '../images/NewAws.png';

function LandingPage() {
  const { isAuthenticated, initiateSignIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);
  // return (
  //   <AppLayout
  //       navigationHide={true}
  //       content={<MainContent />}
  //       toolsHide={true}
  //   />
  // )
  // }
  // const { initiateSignIn } = useAuth();

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo-section">
          <img src={AwsLogo} alt="AWS Logo" style={{ width: '100px', height: 'auto' }}   ></img>
        </div>
        <h1>AWS Eloquence</h1>
        <div>Your AI-Powered Conversation Coach
          <br></br>
          <br></br>
        </div>

        <button
          className="login-button"
          onClick={initiateSignIn}
        >
          Sign in with Midway
        </button>
      </div>
    </div>
  );
}

function MainContent() {
  const { isAuthenticated, initiateSignIn } = useAuth();

  if (isAuthenticated) {
    return null; // This will prevent any flicker before the redirect happens
  }
  return (
    <>
      <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Sign in", href: "/login" },
        ]}
        ariaLabel="Breadcrumbs"
      />
      <ContentLayout
        defaultPadding
        // headerBackgroundStyle="linear-gradient(135deg, rgb(71, 17, 118) 3%, rgb(131, 57, 157) 44%, rgb(149, 85, 182) 69%, rgb(145, 134, 215) 94%)"
        headerVariant="high-contrast"
        maxContentWidth={2000}
        disableOverlap
        header={
          <SpaceBetween size="m">
            <Header variant="h1" description="Sign in here">Welcome to AWS Eloquence</Header>
          </SpaceBetween>
        }
      >

        <br></br>
        <SpaceBetween size="l">
          <Button variant="primary" onClick={initiateSignIn}>
            Sign in with Midway
          </Button>
        </SpaceBetween>
      </ContentLayout>
    </>
  )
}
function Navigation() {
  return (
    <SideNavigation
      header={{ text: 'AWS Eloquence', href: '/' }}
      items={[
        { type: 'link', text: 'Learn More', href: '/learnmore' },
        { type: 'link', text: 'Get Started', href: '/getstarted' },
        { type: 'link', text: 'My Meetings', href: '/meetings' },
        { type: 'link', text: 'Meet the Team', href: '/meettheteam' },
        { type: 'link', text: 'Architecture Diagram', href: '/architecture' },
        { type: 'divider' },
        { type: 'link', text: 'Documentation', href: '/documentation' },
      ]}
    />
  );
}

export default LandingPage;
